let mainInsectsSlider = $('.insects-slider'),
    popupInsectsSlider = $('.insects-slider__popup-wrapper'),
    popupCloseButton = $('.insects-slider__popup_close'),
    popupWindow = $('.protect-against__popup');

popupInsectsSlider.slick({
    asNavFor: '.insects-slider',
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    appendDots: $('.insects-popup-slide__slider-dots'),
    appendArrows: $('.insects-popup-slide__slider-nav'),
    fade: true,
    cssEase: 'linear',
    centerMode: true,
    rows: 0,
    swipe: false,
    responsive: [
        {
            breakpoint: 1399,
            settings: {
                fade: true,
                cssEase: 'linear',
                asNavFor: '.insects-slider',
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                appendDots: $('.insects-popup-slide__slider-dots'),
                appendArrows: $('.insects-popup-slide__slider-nav'),
                rows: 0,
            },
        }],
});
mainInsectsSlider.slick({
    asNavFor: '.insects-slider__popup-wrapper',
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '410px',
    arrows: true,
    focusOnSelect: true,
    rows: 0,
    variableWidth: true,
    responsive: [
        {
            breakpoint: 1719,
            settings: {
                asNavFor: '.insects-slider__popup-wrapper',
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '0',
                arrows: true,
                variableWidth: true,
                rows: 0,
            },
        },
        {
            breakpoint: 1023,
            settings: {
                asNavFor: '.insects-slider__popup-wrapper',
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '0',
                arrows: true,
                variableWidth: true,
                rows: 0,
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '0px',
                arrows: true,
                asNavFor: '.insects-slider__popup-wrapper',
                rows: 0,
            },
        },
    ],
});

$(document).on('click', '.insects-slider .slick-current', function () {
    popupWindow.fadeIn();
    $('body').addClass('fix')
    popupInsectsSlider.slick('refresh');
});
popupCloseButton.on('click', function () {
    popupWindow.fadeOut();
    $('body').removeClass('fix');
});
popupWindow.on('click', function (e) {
    if ($(e.target).hasClass('protect-against__popup')) {
        popupWindow.fadeOut();
        $('body').removeClass('fix');
    }
});
$('.seo-text__show').on('click', function (e) {
    e.preventDefault();
    $('.seo-text').addClass('show');
})
$('.seotext__hide').on('click', function (e) {
    e.preventDefault();
    $('.seo-text').removeClass('show');
})



// WEBPACK FOOTER //
// ./scripts/modules/protect-against.js